import { render, staticRenderFns } from "./SectionDivider.vue?vue&type=template&id=6facaa0b&scoped=true"
import script from "./SectionDivider.vue?vue&type=script&lang=js"
export * from "./SectionDivider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6facaa0b",
  null
  
)

export default component.exports